/** @format */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { productSocialContentReducers } from './+state/reducers/product-social-content.reducer';

@NgModule({
	imports: [
		CommonModule,
		StoreModule.forFeature('productSocialContent', productSocialContentReducers)
	],
	exports: [StoreModule]
})
export class SocialContentDataAccessModule {}
